import { render, staticRenderFns } from "./addPrivacy.vue?vue&type=template&id=058a8660&"
import script from "./addPrivacy.vue?vue&type=script&lang=js&"
export * from "./addPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058a8660')) {
      api.createRecord('058a8660', component.options)
    } else {
      api.reload('058a8660', component.options)
    }
    module.hot.accept("./addPrivacy.vue?vue&type=template&id=058a8660&", function () {
      api.rerender('058a8660', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/components/addPrivacy.vue"
export default component.exports